import sortBy from 'lodash-es/sortBy'
import isEqual from 'lodash-es/isEqual'
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {
      activePreset: null,

      // presets which available by API, each view can have a few presets
      // [{<preset-details>}, ...]
      availablePresets: [],

      // currently applied filter values for each view,
      // updates every time when user applies a filter
      // urlPath: {<parameters>}
      currentFilterSettings: {},

      // true when a saved preset filters are the same with a dashboard filters
      isPresetMatchFilters: false,
      lockPresetsSelector: false,
    };
  },

  getters: {
    isPresetMatchFilters(state) {
      return state.isPresetMatchFilters;
    },

    getLockPresetsSelector(state) {
      return state.lockPresetsSelector;
    },

    getCurrentFilterSettings(state) {
      return state.currentFilterSettings;
    },

    getActivePreset(state) {
      return state.activePreset;
    },

    getAllPresets(state) {
      if(!state.availablePresets) {
        return [];
      }
      return state.availablePresets;
    },
  },

  mutations: {
    setStateValue(state, {name, value}) {
      state[name] = value;
    },

    setActivePreset(state, presetId) {
      let result = state.availablePresets.find(view => view.viewId === presetId);
      state.activePreset = result || null;
    },

    setCurrentFilterSettings(state, {path, parameters}) {
      state.currentFilterSettings[path] = {
        ...state.currentFilterSettings[path] || {},
        ...parameters,
      };

      // console.log(
      //   'setCurrentFilterSettings',
      //   JSON.stringify(state.currentFilterSettings[path], null, 2),
      // );
    },

    updateIsPresetMatchFilters(state, path) {
      if(!state.availablePresets) {
        state.isPresetMatchFilters = false;
      }

      let { activePreset, currentFilterSettings } = state;
      activePreset = activePreset ? activePreset.params : null;
      currentFilterSettings = currentFilterSettings[path] || null;

      state.isPresetMatchFilters = isEqual(activePreset, currentFilterSettings);
    },

    setAvailablePresets(state, presets) {
      state.availablePresets = sortBy(presets, ['view_name', 'label']);
    },
  },

  actions: {
    updateCurrentFilterSettings(store, {path, parameters}) {
      // we can't call a mutation from a mutation, so it's requied to have an action for these 2 commits
      store.commit('setCurrentFilterSettings', {path, parameters});
      store.commit('updateIsPresetMatchFilters', path);
    },

    async loadAllPresets(store) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/views',
          data: undefined,
        }
      );

      if (response.error) {
        console.log('api error', response);
        return null;
      }

      store.commit('setAvailablePresets', response.data.views);
      return true;
    },

    async saveCurrentFilterSettings(store, {path, label}) {
      const viewData = {
        view_name: path,
        label: label,
        params: store.state.currentFilterSettings[path],
      };

      // console.log('saveCurrentFilterSettings', path, JSON.stringify(viewData, null, 2));

      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/views',
          data: viewData,
        }
      );

      if (response.error) {
        console.log('api error', response);
        return null;
      }

      await store.dispatch('loadAllPresets');
      return response.data;
    },

    async removePreset(store, presetId) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'delete',
          apiUrl: `/views/${presetId}`,
          data: undefined,
        }
      );

      if (response.error) {
        console.log('api error', response);
        return null;
      }

      return store.dispatch('loadAllPresets');
    },

    async apiRequest(store, parameters) {
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        { root: true },
      );
    },
  },
}
